import { LayoutOrder } from './layout/LayoutOrder'

export const OrderScreen = () => {
    return (
        <LayoutOrder />
    )
}
